if (!customElements.get("m-icon-boxv")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength =
        this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.4,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,
        navigation: this.showNavigation,
        autoplay: {
          enabled: false, // disable Swiper autoplay, we control videos manually
          delay: false,
          disableOnInteraction: false,
        },
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
          },
          1280: {
            slidesPerView: 3.8,
          },
        },
        on: {
          init: function () {
            this.slideToLoop(__this.lastActive);
            setTimeout(() => {
              const firstItem =
                __this.querySelector(".m-image") ||
                __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty(
                  "--offset-top",
                  parseInt(itemHeight) / 2 + "px"
                );
                prevButton?.classList.remove("m:hidden");
                nextButton?.classList.remove("m:hidden");
              }
            }, 200);

            // 🎥 Play video on init
            __this.handleVideoPlayback(this);
          },
          slideChange: function () {
            // 🎥 Play video on slide change
            __this.handleVideoPlayback(this);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      // ✅ Removed buggy hover-to-slide code

      if (this.slider && this.showNavigation) {
        prevButton?.addEventListener("click", () => this.slider.slidePrev());
        nextButton?.addEventListener("click", () => this.slider.slideNext());
      }

      document.addEventListener("shopify:block:select", (e) =>
        this.onBlockSelect(e)
      );
    }

    // 🎥 Video autoplay logic
    handleVideoPlayback(swiper) {
      // Pause & mute all videos
      swiper.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (video) {
          video.pause();
          video.muted = true;
        }
      });

      // Play only active video
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) {
        const activeVideo = activeSlide.querySelector("video");
        if (activeVideo) {
          activeVideo.muted = false; // set to true if you want silent autoplay
          activeVideo.play().catch(() => {});
        }
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-boxv", MIconbox);
}
